exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-record-title[data-v-0a183963]{margin-bottom:16px;color:#303133;font-weight:600}.record-type[data-v-0a183963]{font-weight:600}.record-type-recycle[data-v-0a183963]{color:#f56c6c}.record-type-grant[data-v-0a183963]{color:#67c23a}.record-status-text--primary[data-v-0a183963]{color:#409eff}.record-status-text--success[data-v-0a183963]{color:#67c23a}.record-status-text--danger[data-v-0a183963]{color:#f56c6c}.record-status-text--info[data-v-0a183963]{color:#909399}", ""]);

// exports
